/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const CONTENT_CATEGORY_ARTICLE_RESULTS_PER_PAGE = 12;

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const AUTHOR_ARTICLE_RESULTS_PER_PAGE = 3;

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const AUTHOR_CAROUSEL_RESULTS_PER_PAGE = 50;

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const FEATURED_ARTICLES_COUNT = 3;
